export default {"src":"/_next/static/media/Use Cases.e84a5cab.svg","height":289,"width":367,"blurWidth":0,"blurHeight":0};